<script>
    import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink
  } from '@sveltestrap/sveltestrap';

  import globaldata from '/core/stores/siteData';

  let isOpen = false;

  function handleUpdate(event) {
    isOpen = event.detail.isOpen;
  }
</script>

<section>
<Navbar color="primary" dark expand="md">
    <NavbarBrand href="/">{$globaldata.name}</NavbarBrand>
    <NavbarToggler on:click={() => (isOpen = !isOpen)} />
    <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
      <Nav class="ms-auto" navbar>
        <NavItem>
            <NavLink href="/login">
                <span class="fas fa-sign-in-alt"></span> Login
            </NavLink>
        </NavItem>
      </Nav>
    </Collapse>
  </Navbar>
  </section>
